export const tooltipSlotProps = {
	tooltip: {
		sx: {
			fontSize: 12,
			padding: "10px 12px",
			borderRadius: 1.5,
			boxShadow: "0 10px 30px -10px #0F172A80",
			maxWidth: 320,
		},
	},
};
